import { render, staticRenderFns } from "./CartBasicData.vue?vue&type=template&id=0259679b"
import script from "./CartBasicData.vue?vue&type=script&lang=js"
export * from "./CartBasicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports